(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .controller('AboutModalController', AboutModalController);

    AboutModalController.$inject = ['$modalInstance', '$q', 'authentication', 'config', 'stayOpen'];

    function AboutModalController($modalInstance, $q, authentication, config, stayOpen) {
        var vm = this;
        vm.title = "About Account Management";

        vm.isLoading = true;

        vm.stayOpen = stayOpen;

        vm.amUi = {
            display: false,
            version: "-",
            date: "-",
            url: "",
            numericalVersion: "-"
        };
        vm.coreApi = {
            version: "-",
            online: false
        };
        vm.cas = {
            version: "-",
            online: false
        };

        var promises = [];

        promises.push(config.get().then(function (configData) {
            vm.amUi = configData.build;
            vm.amUi.numericalVersion = APP_VERSION; // From app/common/version.js
        }));

        // Get Core API version through check_health

        promises.push(authentication.checkCoreApiHealth(["cas"]).then(function (healthData) {
            vm.coreApi.version = healthData.apiVersion;
            vm.coreApi.online = healthData.success;
            vm.cas.online = healthData.CAS.healthy;
        }));

        // Get SSO (CAS) version through custom endpoint

        // Note: Could use success here as CAS being "online" instead of above health check
        promises.push(authentication.checkSsoHealth().then(function (version) {
            vm.cas.version = version.version;
        }));

        $q.all(promises).catch(function (error) {
            console.error(error);
        }).finally(function () {
            vm.isLoading = false;
        });
    }
})();
